<template>
    <NavBar color="black" :ellipsis="false">
        <template v-slot:title>
            <span class="nav-title">权益中心</span>
        </template>
    </NavBar>
    <van-overlay :show="redeem.id" class="success-overlay">
        <Redeem :redeem="redeem" :id="redeem.id" :code="redeem.code" :platform="redeem.use" @close="redeem = {}"></Redeem>
    </van-overlay>
    <div class="box">
        <!-- <div class="item" v-for="welfare in welfares" :key="welfare.id">
            <p class="name">{{welfare.name}}</p>
            <router-link :to="'/welfare/' + welfare.id" class="active" v-if="! welfare.receiver_mobile">点击填写地址</router-link>
            <router-link :to="'/welfare/' + welfare.id" v-else>已填写联系方式</router-link>
        </div> -->
        <div v-show="! loading && welfares.length <= 0" class="list-null">
            <van-empty
                :image="require('@/assets/images/kong.png')"
                description="暂无权益"
            />
        </div>
        <div class="new-item" v-for="welfare in welfares" :key="welfare.id">
            <div class="bg">
                <img :src="welfare.cover" class="cover" alt="">
                <div class="content">
                    <p class="name two_line">{{ welfare.name }}</p>
                    <p class="time" v-if="welfare.start_time">有效期：{{ dateFormat('YYYY-mm-dd', welfare.start_time) }}-{{ dateFormat('YYYY-mm-dd', welfare.end_time) }}</p>
                    <a href="javascript:;" class="button" v-if="welfare.code" @click="redeem = welfare">领取兑换码</a>
                    <div class="button" :class="{disable: welfare.receiver_mobile}" style="width: 100%;" v-else>
                        <div class="receiver receiver_after" v-if="welfare.receiver_mobile">
                            <div style="flex: 1;">
                                <span class="tag">已填写</span>
                            </div>
                            <div @click="$router.push('/welfare/' + welfare.id)">修改地址</div>
                        </div>
                        <div class="no_receiver" @click="$router.push('/welfare/' + welfare.id)" v-else>点击填写地址</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="division" v-if="overdueWelfares.length">
            <div></div>
        </div>
        <div class="new-item" v-for="welfare in overdueWelfares" :key="welfare.id">
            <div class="bg">
                <img :src="welfare.cover" class="cover" alt="">
                <div class="content">
                    <p class="name two_line" style="color: rgba(52, 58, 64, 0.60);">{{ welfare.name }}</p>
                    <p class="time" style="color: rgba(52, 58, 64, 0.50);"
                       v-if="welfare.start_time">
                        有效期：{{ dateFormat('YYYY-mm-dd', welfare.start_time) }}-{{ dateFormat('YYYY-mm-dd', welfare.end_time) }}
                    </p>
                    <img src="@/assets/images/overdue.png" class="overdue" alt="" v-if="!welfare.use_status">
                    <img src="@/assets/images1/welfare/used.png" class="overdue" alt="" v-if="welfare.code && welfare.use_status">
                    <div class="button" :class="{disable: welfare.receiver_mobile}" style="width: 100%;" v-if="!welfare.code && welfare.use_status">
                        <div class="receiver" :class="{receiver_after: !welfare.overdue}">
                            <div style="flex: 1;">
                                <span class="tag">已填写</span>
                            </div>
                            <div @click="$router.push('/welfare/' + welfare.id)" v-if="!welfare.overdue">修改地址</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>